import React, {
    ReactElement, useEffect, useRef,
} from "react";
import Confetti from "react-confetti";
import useArticleContext from "../../../../contexts/HelpContext";
import useCurrentSession from "../../../../contexts/UserContext";
import { useGetBillingQuery } from "../../../../__generated__/api";
import { LoadingIcon } from "../../../../components/loading/Loading";

/* eslint-disable @typescript-eslint/no-namespace */
declare global {
    namespace JSX {
        interface IntrinsicElements {
            "stripe-pricing-table": React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
        }
    }
}
/* eslint-enable @typescript-eslint/no-namespace */

export function BillingSuccess(): ReactElement {
    return (
        <div className="full-page">
            <div className="centered-container centered-container-lg pt-5 align-items-center">

                <h4 className="text-center w-100 mb-4">
                    🎉 Thanks for signing up!
                </h4>

                <Confetti
                    width={document.body.clientWidth}
                    height={document.body.scrollHeight}
                    initialVelocityY={30}
                    initialVelocityX={20}
                    numberOfPieces={300}
                    recycle={false}
                    confettiSource={{
                        /* eslint-disable id-length */
                        x: 0,
                        y: document.body.scrollHeight,
                        w: 0,
                        h: 0,
                        /* eslint-enable id-length */
                    }}
                />
                <Confetti
                    width={document.body.clientWidth}
                    height={document.body.scrollHeight}
                    initialVelocityY={30}
                    initialVelocityX={-20}
                    numberOfPieces={300}
                    recycle={false}
                    confettiSource={{
                        /* eslint-disable id-length */
                        x: document.body.clientWidth,
                        y: document.body.scrollHeight,
                        w: 0,
                        h: 0,
                        /* eslint-enable id-length */
                    }}
                />

                <div className="text-center">
                    You can now start using the full power of the platform.
                </div>

            </div>

        </div>
    );
}

export default function BillingSettings(): ReactElement {
    useArticleContext("urn:fq:article:67d9c5ea6d6c4cbd8ec38dcd75459521");
    const { user } = useCurrentSession();

    const ref = useRef<HTMLDivElement>();
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://js.stripe.com/v3/pricing-table.js";
        script.nonce = window.NONCE;
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const { data, loading: isLoading } = useGetBillingQuery();

    if (data?.billing?.redirectUrl) {
        window.location.href = data?.billing?.redirectUrl;
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <></>;
    }
    return (

        <div className="border p-5 rounded bg-white">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="text-light mb-0">
                    Account Setup
                </h5>
            </div>
            <div ref={current => {
                if (ref) {
                    ref.current = current as HTMLDivElement;
                }
            }}
            />
            {isLoading ? <LoadingIcon /> : (
                <stripe-pricing-table
                    pricing-table-id={data?.billing?.pricingTableId}
                    publishable-key={data?.billing?.publishableKey}
                    client-reference-id={data?.billing?.sessionId}
                    customer-email={data?.billing?.currentUserEmail}
                />
            )}

        </div>
    );
}
